// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__6G7e9","rootSmall":"AddTileButton_rootSmall__H19eh"};